import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Container, SectionHeader, EnhancedSectionTitle, SectionSubtitle } from '../../styles/sharedComponents';
import ComparisonCard from './ComparisonCard';
import { ComparisonSectionWrapper, ComparisonGrid, ComparisonFooter, ComparisonFooterText } from './styles';

const ComparisonSection: React.FC = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      {
        threshold: 0.1,
        rootMargin: '100px'
      }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, []);

  const competitors = [
    {
      name: 'N8N',
      logo: '/icons/loopra_icon_profile.webp',
      loopraFeatures: [
        t('comparison.n8n.loopra.item1'),
        t('comparison.n8n.loopra.item2'),
        t('comparison.n8n.loopra.item3'),
        t('comparison.n8n.loopra.item4')
      ],
      competitorFeatures: [
        t('comparison.n8n.competitor.item1'),
        t('comparison.n8n.competitor.item2')
      ]
    },
    {
      name: 'Zapier',
      logo: '/icons/loopra_icon_profile.webp',
      loopraFeatures: [
        t('comparison.zapier.loopra.item1'),
        t('comparison.zapier.loopra.item2'),
        t('comparison.zapier.loopra.item3'),
        t('comparison.zapier.loopra.item4')
      ],
      competitorFeatures: [
        t('comparison.zapier.competitor.item1'),
        t('comparison.zapier.competitor.item2')
      ]
    },
    {
      name: 'Make',
      logo: '/icons/loopra_icon_profile.webp',
      loopraFeatures: [
        t('comparison.make.loopra.item1'),
        t('comparison.make.loopra.item2'),
        t('comparison.make.loopra.item3'),
        t('comparison.make.loopra.item4')
      ],
      competitorFeatures: [
        t('comparison.make.competitor.item1'),
        t('comparison.make.competitor.item2')
      ]
    }
  ];

  return (
    <ComparisonSectionWrapper ref={ref} $isVisible={isVisible} id="comparison">
      <Container>
        <SectionHeader>
          <EnhancedSectionTitle>{t('comparison.title')}</EnhancedSectionTitle>
          <SectionSubtitle>
            {t('comparison.subtitle')}
          </SectionSubtitle>
        </SectionHeader>

        <ComparisonGrid>
          {competitors.map((competitor, index) => (
            <ComparisonCard
              key={competitor.name}
              competitor={competitor}
              delay={index}
              isVisible={isVisible}
            />
          ))}
        </ComparisonGrid>

        <ComparisonFooter>
          <ComparisonFooterText dangerouslySetInnerHTML={{ __html: t('comparison.footer') }} />
        </ComparisonFooter>
      </Container>
    </ComparisonSectionWrapper>
  );
};

export default ComparisonSection;
